import { useApp } from '@k3/core'
import { Box, Typography } from '@mui/material'
import { useProgress } from '@react-three/drei'

export const SuspenseLoader = (): JSX.Element => {
  const { progress } = useProgress()
  const app = useApp()
  // TODO: Small workaround - better show Dealer logo, but no @k3-core hook available
  const urlParams = new URLSearchParams(window.location.search)
  const dealer = urlParams.get('dealer');

  const loadingImg: string =
    app.settings.logo !== ''
      ? (app.settings.logo as string)
      : 'image/companyLogo.png'

  const loadingClass = app.settings.logo === '' ? 'loader' : 'loader-logo'

  return (
    <Box
      height={'100%'}
      width={'100%'}
      bgcolor={'white'}
      component={'div'}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {!!(!dealer) && (
        <img src={loadingImg} alt={'loading screen'} className={loadingClass} />
      )}
      <Typography className={'progress-loader'}>
        {progress.toFixed(0)} %
      </Typography>
    </Box>
  )
}
